module.exports = __webpack_public_path__ + "img/arrows-from-dotted-line.a9df0226.svg";